import { Variant } from "../../../../Interfaces/Product";
import { IConfiguratorUpdater } from "../types";
import { SELECTORS } from "../Constants";

interface ICampProps {
    _camp_price?: string;
    _camp_hash?: string;
}

interface CampaignPrice {
    id: number;
    campaign_price: number;
    hash: string;
}

export class CampProps implements IConfiguratorUpdater {
    private variant: Variant;
    private campaign: CampaignPrice[];
    private ctaButtons: NodeListOf<HTMLElement>;
    //private campPrice: CampaignPrice | undefined;

    constructor(private readonly node: HTMLElement) {
        this.node = node;
        this.campaign = JSON.parse(this.node.dataset.campaign);
        this.ctaButtons = document.querySelectorAll<HTMLElement>(SELECTORS.CTA);
    }

    /**
     * update properties data set
     * @param v
     */
    public update(v: Variant) {
        const props: ICampProps = {};

        this.variant = v;
        const c = this.campaign.find((el) => el.id == this.variant.id);
        this.ctaButtons.forEach((cta) => {
            if (c !== undefined) {
                props._camp_price = String(c.campaign_price);
                props._camp_hash = String(c.hash);
                cta.dataset.properties = JSON.stringify(props);
            } else if (cta.dataset.properties) {
                delete cta.dataset.properties;
            }
        });
    }
}
